<template>
    <div>
        <div v-if="searchUrlInsPosts != null && isInstagram && profileData">
            <div class="user-profile">
                <div class="user-profile__avatar">
                    <img :src="this.profileData.profilePicture" alt="user-avatar" class="avatar" @error="handleLoadErrorImage()" ref="avatarImageRef">
                    <a v-if="this.profileData.downloadableAvatarUrl" :href="profileData.downloadableAvatarUrl" download="true">
                        <img src="/img/icons/download.svg" class="avatar-dl-icon">
                    </a>
                </div>
                <div class="user-profile__content profile">
                    <div class="profile__nickname">{{ this.profileData.username ? `@${this.profileData.username}` : '' }}</div>
                    <div class="profile__stats">
                        <div class="stats-item">
                            <div class="stats-item__value">{{ formatNumber(this.profileData.edge_owner_to_timeline_media.count) }}</div>
                            <div class="stats-item__label">Posts</div>
                        </div>
                        <div class="stats-item">
                            <div class="stats-item__value">{{ formatNumber(this.profileData.edge_followed_by.count) }}</div>
                            <div class="stats-item__label">Followers</div>
                        </div>
                        <div class="stats-item">
                            <div class="stats-item__value">{{ formatNumber(this.profileData.edge_follow.count) }}</div>
                            <div class="stats-item__label">Following</div>
                        </div>
                    </div>
                    <div class="profile__description">{{ this.profileData.full_name }}</div>
                </div>
            </div>
            <div class="switch-container" v-if="this.profileData">
                <button v-bind:class="['switch-btn', activBtn === 'posts' ? 'switch-btn--active' : null]"
                        @click="activePage('posts')"> Posts </button>
                <button v-bind:class="['switch-btn', activBtn === 'stories' ? 'switch-btn--active' : null]"
                        @click="activePage('stories')"> Stories </button>
                <button v-bind:class="['switch-btn', activBtn === 'highlights' ? 'switch-btn--active' : null]"
                        @click="activePage('highlights')"> Highlights </button>
                <button v-bind:class="['switch-btn', activBtn === 'reels' ? 'switch-btn--active' : null]"
                        @click="activePage('reels')"> Reels </button>

            </div>
            <highlights-component
                            v-if="activBtn == 'highlights'"
                            :highlights="highlights"
                            :abortController="abortController"
                            @highlightClick="handleHightlightClick"
                            @dropHighlight="dropHighlight"
                            @startLoading="startLoading"
                            @endLoading="endLoading"
                >
            </highlights-component>
            <main-results v-if="activBtn == 'posts' && searchUrlInsPosts !== null" :activBtn="activBtn"
                          :searchUrlInsPosts="searchUrlInsPosts" :key="'posts'"
                          @startLoading="startLoading" @endLoading="endLoading">
            </main-results>
            <main-results v-if="activBtn == 'stories'"
                          :activBtn="activBtn"
                          :stories="stories" :key="'stories'"
                          @loadStories="loadStories"
                          @startLoading="startLoading" @endLoading="endLoading">
            </main-results>

            <main-results v-if="activBtn == 'highlights' && highlightStories" :activBtn="activBtn"
                           :key="'highlights'" :highlightStories="highlightStories"
                           @startLoading="startLoading"
                            @endLoading="endLoading">

            </main-results>
            <main-results v-if="activBtn == 'reels' && searchUrlInsReels !== null" :activBtn="activBtn"
                          :searchUrlInsReels="searchUrlInsReels" :key="'reels'"
                          @startLoading="startLoading" @endLoading="endLoading">
            </main-results>

        </div>
        <div v-if="error">
            <ErrorBlock :error="error" />
        </div>

        <loader-component v-if="isLoading" :isLoading="isLoading"></loader-component>

        <div class="norton">
            <p>Scanned by</p>
            <img loading="lazy" src="/img/norton.svg" alt=''>
            <p>Norton<sup>TM</sup> Safe Web</p>
        </div>
    </div>
</template>

<script>
import LoaderComponent from "./LoaderComponent.vue";
import ErrorBlock from "./ErrorBlock";
import HighlightsComponent from "./HighlightsComponent";
import MainResults from './MainResults.vue'; // posts //stories
import formatNumber from "../tools/formatNumber";
import mediaUrlProcessor from '../tools/MediaUrlProcessor'
import noAvatarImagePicture from "../../img/placeholder/no-avatar.png";
import adaptStories from "../tools/adaptStories";
import { isProfileLink, isProfileQuery, isInstagramContext } from '../tools/instagramLinks';
import { IgApi } from "../api/instagram";
import { NOT_FOUND_MESSAGE } from '../tools/convertFormats';

export default {
    components: {
        ErrorBlock,
        MainResults,
        HighlightsComponent,
        LoaderComponent
    },
    data() {
        return {
            error: null,
            activBtn: null,
            isInstagram: null,
            searchUrlInsPosts: null,
            searchUrlInsReels: null,
            stories: null,
            highlights: null,
            highlightStories: null,
            input: null,
            urlAddress: -1,
            profileData: null,
            abortController: new AbortController(),
            isLoading: false
        }
    },
    mounted() {
        this.$root.$on('clear-results', () => {
            this.error = null;
            this.highlights = null;
            this.highlightStories = null,
            this.stories = null;
            this.profileData = null;
        });
        this.$root.$on('profile-request', (string) => {
            this.highlights = null;
            this.highlightStories = null,
            this.stories = null;
            this.profileData = null;
            if (string === null) {
                this.searchUrlInsPosts = null;
                this.searchUrlInsReels = null;
                this.input = null;
            } else {
                this.searchRequest(string)
            }
        });
        this.$root.$on('link-insert', (link) => {
            this.searchRequest(link)
        })
        this.$root.$on('handleError', (response, message) => {
            this.handleError(response, message)
        })
    },
    methods: {
        handleError(result, message = null) {
            console.log(message)
            this.$root.$emit('show-error', result, this.link);
            this.error = message ? { message } : true;
        },
        searchRequest(string) {
            // Предикат тот же, по которому SearchForm маршрутизирует ввод сюда, иначе
            // ссылка вида instagr.am/user доходила бы до этого метода и выходила молча.
            this.isInstagram = isInstagramContext(string) || isProfileQuery(string)
            this.urlAddress = string.search(/^http|^https:\/\/|^www\.|^instagram\.com|instagr\.am/gi)
            if (!this.isInstagram) {
                this.handleError(true, 'Please paste an Instagram profile link or @username')
                return
            }
            if (string[0] === "@") {
                this.input = string.substring(1)
            } else if (isProfileLink(string)) {
                string = string.trim().match(/[\d\w-_.]+\/?$/gims)[0];
                if (string[string.length - 1] === '/') {
                    string = string.substring(0, string.length - 1)
                }
                this.input = string;
            } else {
                this.input = string;
            }
            this.loadUserData()
            this.activePage()
        },
        download(link) {
            this.$root.$emit('download-click', this.link, 'mp4');
            setTimeout(() => {
                document.location = link;
            }, 500);
        },
        async loadProfile() {
            if(this.abortController){
                this.abortController.abort()
                this.abortController = new AbortController()
            }
            this.startLoading()
            const input = this.input.trim()
            return IgApi.getProfile({
                username: input,
                signal: this.abortController.signal,
                subscribeSignedRequestBody: this.$root.subscribeSignedRequestBody,
            }).then((response) => {
                // 200 без профиля (например { success: false, response_type: 'link not found' }) — как 404, тем же текстом,
                // что ошибки «не найдено» по всему сайту (NOT_FOUND_MESSAGE);
                // profileData не трогаем (undefined прошёл бы проверку шаблона и уронил рендер вместе с блоком ошибки)
                if (!response.data || !response.data.result) {
                    this.error = { message: NOT_FOUND_MESSAGE }
                    return null
                }
                this.profileData = response.data.result;
                this.profileData.profilePicture = response.data.result.profile_pic_url_wrapped || mediaUrlProcessor.getPreviewUrl(
                    response.data.result.profile_pic_url,
                    response.data.result.profile_pic_url_signature
                )
                this.profileData.downloadableAvatarUrl = response.data.result.profile_pic_url_downloadable || mediaUrlProcessor.getDownloadableUrl(
                    response.data.result.profile_pic_url,
                    response.data.result.profile_pic_url_signature
                );
                return this.profileData
            }).catch((error) => {
                if(error.response && error.response.status === 404){
                    this.error = { message: NOT_FOUND_MESSAGE }
                } else {
                    this.error = true
                }
            })
            .finally(() => {
                this.endLoading()
            })
        },
        async loadHighlights(profileId) {
            if(this.abortController){
                this.abortController.abort()
                this.abortController = new AbortController()
            }
            this.startLoading()
            return IgApi.getHighlights({
                profileId,
                signal: this.abortController.signal,
                subscribeSignedRequestBody: this.$root.subscribeSignedRequestBody,
            }).then((response) => {                
                this.highlights = response.data.result.map(highlight => {
                    const preview = highlight.cover_media.cropped_image_version.url_wrapped || mediaUrlProcessor.getPreviewUrl(highlight.cover_media.cropped_image_version.url,
                    highlight.cover_media.cropped_image_version.url_signature);
                    
                    return {
                        preview,
                        id: highlight.id,
                        title: highlight.title
                    }
                })
                return this.highlights
            })
                .catch((error) => {
                    this.error = true
                })
                .finally(() => this.endLoading())
        },
        async loadStories() {
            if(this.abortController){
                this.abortController.abort()
                this.abortController = new AbortController()
            }
            this.startLoading()
            return IgApi.getStories({
                userId: this.profileData.id,
                username: this.profileData.username,
                signal: this.abortController.signal,
                subscribeSignedRequestBody: this.$root.subscribeSignedRequestBody,
            }).then((response) => {
                if(!response.data.result){
                    this.stories = []
                    return []
                }
                const result = adaptStories(response.data.result)

                this.stories = result
                return result
            })
                .catch((error) => {
                    this.error = true
                })
                .finally(() => this.endLoading())
        },
        async loadUserData(){
            return this.loadProfile().then((profile) => {
                // профиль не загружен — ошибка уже показана, хайлайтов нет
                if (profile) this.loadHighlights(profile.id)
            })
        },
        formatNumber(number) {
            return formatNumber(number);
        },
        handleHightlightClick(
            highlightStories,
            abortController
        ) {
            this.highlightStories = highlightStories;
            this.abortController = abortController;
            this.endLoading()

        },
        dropHighlight(){
            this.highlightStories = null
        },
        startLoading() {
            this.isLoading = true
        },
        endLoading() {
            this.isLoading = false
        },
        activePage(page = 'posts') {
            if(this.activBtn !== page && !!this.activeBtn){
                this.abortController.abort()
                this.abortController = new AbortController()
            }
            this.activBtn = page;
            this.error = null
            if (this.input) {
                this.searchUrlInsPosts = `https://www.instagram.com/${this.input}/`;
                this.searchUrlInsReels = `https://www.instagram.com/${this.input}/reels/`;
            }
        },
        handleLoadErrorImage() {
            this.$refs.avatarImageRef.src = noAvatarImagePicture;
        },
    }
}
</script>
../tools/instagramLinks
